import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Campionati from "./pages/Campionati";
import Gare from "./pages/Gare";
import Calendario from "./pages/Calendario";
import GalleryPage from "./pages/GalleryPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/campionati" element={<Campionati />} />
          <Route path="/gare" element={<Gare />} />
          <Route path="/calendario" element={<Calendario />} />
          <Route path="/gallery" element={<GalleryPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
